<template>
  <div class="contact">
    <h4>Contato</h4>
    <hr>
    <form action="https://formsquash.io/f/fqoCoTspaAP0zex9O6P2" method="POST">
      <fieldset>
        <input type="hidden" name=" FORMULÁRIO DE CONTATO" value="" />

        <div class="form-group col-6">
          <label>Nome</label>
          <input class="form-control" type="text" name="1) Nome" id="inputName">
        </div>
        <div class="for-group col-6">
          <label>Email</label>
          <input class="form-control" type="email" name="2) E-mail" id="inputEmail">
        </div>
        <div class="form-group col-6">
          <label>Mensagem</label>
          <textarea class="form-control" name="3) Mensagem" rows="5" id="textareaMensagem"></textarea>
        </div>
        <div class="form-group col-6">
          <button class="enviar d-none" type="submit">Enviar</button> <!-- Esse fica escondido -->
          <button class="btn btn-primary" type="button" @click="validation()">Enviar</button> <!-- Esse aparece e chama o evento onclick do btn escondido -->
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  methods: {
    validation () {
      const name = document.getElementById('inputName')
      const email = document.getElementById('inputEmail')
      const mensagem = document.getElementById('textareaMensagem')
      if (!name.value) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar nome.',
          type: 'warning'
        })
      } else if (!email.value) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o email.',
          type: 'warning'
        })
      } else if (!mensagem.value) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar a mensagem.',
          type: 'warning'
        })
      } else {
        document.querySelector('.enviar').click()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.contact {
  padding: 40px 60px;
  height: 100%;
  h4 {
    margin-bottom: 15px;
  }
}
</style>
